/**
 * Created by pavelkozhin on 14/03/16.
 */

define([
        'jQuery',
        'underscore',
        'library/fcse-component/optionsMixin',
        'clientComponents/map/baseMap',
        'library/fcse-compatibility/object',
        'library/fcse-events/eventDispatcher'
    ],
    function($, _, OptionsMixin, Map, Object, EventDispatcher) {
        /**
         * // TODO: Refactor
         * MapComponent component
         * @param element
         * @param requestHandler
         * @param options
         * @constructor
         */
        var MapComponent = function(element, requestHandler, options) {
            element = $(element);

            if (!element.length) {
                return;
            }

            // Set default options
            var defaultOptions = {
                placeDetailsRoute: 'allt_frontend.map.place_details',
                placesRoute: 'allt_frontend.map.places',
                mapOpenButtonSelector: '[data-fcse-role="map-overlay-open-button"]',
                mapContainerSelector: '[data-fcse-role="accordion-region-map-container"]',
                productSearch: element.attr('product-search'),
                loadingClass: 'is-loading',
                detailInfoBoxFactory: null,
                placeMarkerImage: '/bundles/alltfrontend/img/hotel-marker-blue.png',
                placeActiveMarkerImage: '/bundles/alltfrontend/img/hotel-marker-red.png'
            };

            this.addOptions(defaultOptions, options);

            this._uid = Math.round(Math.random() * (new Date().getTime()));
            this._detailsInfoBox = null;
            this._tooltipInfoBox = null;
            this._loadingInfoBoxContent = $('<div class="map--info-box--content is-loading"></div>').get(0);
            this._requestHandler = requestHandler;
            this._markerIndex = 1;
            this._productSearch = null;
            this._activePlaceId = null;
            this._isLoading = false;

            Map.apply(this, [element, this.getOptions()]);
            EventDispatcher.apply(this, arguments);

            this.registerEvent("mapCreated");
        };

        MapComponent.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), Object.create(EventDispatcher.prototype), {
            /**
             * Return Google map instance
             * @returns {null|*}
             */
            getMap: function() {
                return this._map;
            },

            /**
             * Adds/removes loading indicator
             * @param isLoading
             */
            setIsLoading: function(isLoading) {
                if (!this._element) {
                    return;
                }
                this._isLoading = isLoading;
                if (isLoading) {
                    this._element.addClass(this.option('loadingClass'));
                } else {
                    this._element.removeClass(this.option('loadingClass'));
                }
            },

            /**
             * Loads places to render markers
             * @param productSearch
             */
            loadMarkers: function(productSearch, activePlaceId) {
                var options = {method: 'POST'};
                var gBounds = null;
                var params = {
                    token: this._uid,
                    productSearch: productSearch
                };
                this._productSearch = productSearch;
                this._activePlaceId = activePlaceId;

                if (_.isArray(this._mapPoints)) {
                    var excludeIds = _.map(this._mapPoints, function(mapPoint) {
                        return mapPoint.data.id;
                    });
                    if (excludeIds.length) {
                        params['excludeIds'] = excludeIds.join(',');
                    }
                }
                gBounds = this._map.getBounds();

                var left = gBounds.getSouthWest().lat();
                var right = gBounds.getNorthEast().lat();
                var top = gBounds.getSouthWest().lng();
                var bottom = gBounds.getNorthEast().lng();

                params['geoPolygon'] =
                    '0,' + left + ',' + top + ';' +
                    '1,' + right + ',' + top + ';' +
                    '2,' + right + ',' + bottom + ';' +
                    '3,' + left + ',' + bottom;

                this.setIsLoading(true);
                this._requestHandler.send(this.option('placesRoute'), params, {}, options);
            },

            /**
             * Removes current markers
             */
            removeMarkers: function() {
                this._updateMarkers(null);
            },

            /**
             * Initializes map component
             * @private
             */
            _init: function()
            {
                var self = this;

                this._requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                this._requestHandler.on('error', $.proxy(this._onLoadContentError, this));

                this._mapElement = $(this.option('mapContainerSelector'), this._element);
                this._mapPoints = this._createMapPoints(this._options.mapPoints);

                var loadingCaptureProxyHandler = $.proxy(this._loadingCaptureClickHandler, this);
                this._element.get(0).addEventListener('click', loadingCaptureProxyHandler, true);

                // Disable pinch zoom on map element
                if (this._options.pinchZoomDisabled){
                    $(this._mapElement)[0].addEventListener('touchmove', this._preventPinchZoom, true);
                }
            },

            /**
             * Creates google map, updates map viewport
             * @param {Object} bounds
             * @param {Array} locations
             * @param {Object} center
             * @param {Number} zoom
             */
            create: function(bounds, locations, center, zoom) {
                if (!this.isCreated) {
                    this._map = new google.maps.Map(this._mapElement.get(0), this._options.mapOptions);
                    this._map.setOptions({
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                            position: google.maps.ControlPosition.RIGHT_TOP
                        }
                    });
                    this.isCreated = true;
                    this.dispatchEvent('mapCreated');
                }

                if (bounds) {
                    var sw = new google.maps.LatLng(bounds.southwest);
                    var ne = new google.maps.LatLng(bounds.northeast);
                    var gBounds = new google.maps.LatLngBounds(sw, ne);
                    this._applyMapBounds(gBounds);
                } else if (locations) {
                    var gBounds = new google.maps.LatLngBounds();
                    _.each(locations, function(location) {
                        gBounds.extend(new google.maps.LatLng(location.latitude, location.longitude));
                    });
                    this._applyMapBounds(gBounds);
                } else if (center) {
                    this._map.setCenter(new google.maps.LatLng(parseFloat(center.lat), parseFloat(center.lng)));
                    this._map.setZoom(zoom || this._options.mapOptions.zoom);
                }
            },

            /**
             * Converts data to MapPoints
             * @param items
             * @returns {*|array}
             * @private
             */
            _createMapPoints: function(items) {
                var points = Map.prototype._createMapPoints.call(this, items);

                if (_.isArray(points)) {
                    _.each(points, function(item, index) {
                        points[index].data = items[index];
                    });
                }
                return points;
            },

            /**
             * Creates detail InfoBox (marker on click info)
             * @returns {window.InfoBox}
             * @private
             */
            _createDetailsInfoBox: function() {
                var options = {
                    content: this._loadingInfoBoxContent,
                    disableAutoPan: false,
                    maxWidth: 250,
                    /*pixelOffset: new window.google.maps.Size(-125, -140),*/
                    alignBottom: true,
                    zIndex: 1001,
                    boxClass: 'map--info-box',
                    /*closeBoxMargin: "12px 4px 2px 2px",*/
                    closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                    infoBoxClearance: new window.google.maps.Size(5, 5)
                };
                var factory = this.option('detailInfoBoxFactory');
                if (_.isFunction(factory)) {
                    return factory(options);
                }
                return new window.InfoBox(options);
            },

            /**
             * Creates InfoBox for tooltip
             * @param Tooltip
             * @returns {*}
             * @private
             */
            _createTooltipInfoBox: function(Tooltip) {
                var options = {
                    content: '',
                    markerOffsetTop: 45,
                    disableAutoPan: true,
                    maxWidth: 200,
                    zIndex: 1000,
                    boxClass: 'map--info-box--tooltip',
                    /*closeBoxMargin: "12px 4px 2px 2px",*/
                    closeBoxURL: " ",
                    infoBoxClearance: new window.google.maps.Size(0, 0)
                };
                if (_.isFunction(Tooltip)) {
                    return new Tooltip(options);
                }
                return new window.InfoBox(options);
            },

            /**
             * Returns rendered tooltip content
             * @param mapPoint
             * @returns {HTMLElement}
             * @private
             */
            _getTooltipContent: function(mapPoint) {
                // TODO: Improve
                var tooltip = $(this._tooltipTemplate);
                if ((new RegExp(/\+/)).test(mapPoint.category)) {
                    mapPoint.category = mapPoint.category.replace(/\+/, '.5');
                }
                var categoryParts = String(mapPoint.category).split('.');
                var categoryHtml = '';
                var duration;
                var priceLocaleParts;
                if (categoryParts[0]) {
                    for (var i = 0; i < categoryParts[0]; i++) {
                        categoryHtml += '<li class="hotel-rating-item">' +
                            '<i class="icon icon-rating-sun icon-large"></i></li>';
                    }
                    if (categoryParts[1]) {
                        categoryHtml += '<li class="hotel-rating-item half">' +
                            '<i class="icon icon-rating-sun-o icon-large half"></i></li>';
                    }
                }

                duration = mapPoint.duration + ' ' +
                    (parseInt(mapPoint.duration) > 1 ?
                        tooltip.attr('data-days-trans') :
                        tooltip.attr('data-day-trans'));

                if (mapPoint.priceLocale) {
                    priceLocaleParts = mapPoint.priceLocale.split(' ');
                }

                var content = this._tooltipTemplate
                    .replace('@name', mapPoint.name)
                    .replace('@category', categoryHtml)
                    .replace('@board', mapPoint.board)
                    .replace('@price', Math.round(parseFloat(mapPoint.price)))
                    .replace('@duration', duration)
                    .replace('@recommendation', mapPoint.recommendation)
                    .replace('@recommendation', mapPoint.recommendation);

                if (priceLocaleParts) {
                    content = content
                        .replace('@locale_price', priceLocaleParts[0])
                        .replace('@locale_currency', priceLocaleParts[1]);
                }

                return $(content).get(0);
            },

            /**
             * Adds and inits markers
             * @param mapPoints
             * @private
             */
            _updateMarkers: function(mapPoints) {
                this._markerIndex = 1;

                if (this._detailsInfoBox) {
                    this._detailsInfoBox.close();
                }
                if (this._tooltipInfoBox) {
                    this._tooltipInfoBox.close();
                }

                // Releasing event listeners
                _.each(this._mapPoints, function(mapPoint) {
                    if (mapPoint.marker) {
                        window.google.maps.event.clearInstanceListeners(mapPoint.marker);
                    }
                });
                Map.prototype._updateMarkers.call(this, mapPoints);

                if (!(mapPoints && mapPoints.length)) {
                    this._mapPoints = [];
                    return;
                }

                this._initMapPoints(mapPoints);
            },

            /**
             * Appends markers to the map
             * @param places
             * @private
             */
            _appendMapPoints: function(places) {
                var self = this;
                var mapPoints = this._createMapPoints(places || []);

                if (_.isArray(mapPoints)) {
                    var image = this.option('placeMarkerImage');
                    var activeImage = this.option('placeActiveMarkerImage');
                    _.each(mapPoints, function(mapPoint) {
                        var isActive = mapPoint.data.id == self._activePlaceId;
                        var icon = isActive ? activeImage : image;
                        mapPoint.marker = new google.maps.Marker({
                            position: mapPoint.latlng,
                            map: self._map,
                            animation: google.maps.Animation.DROP,
                            icon: icon
                        });
                    });
                    this._initMapPoints(mapPoints);
                }
                this._mapPoints = _.union(this._mapPoints, mapPoints);
            },

            /**
             * Inits markers functionality, e.g. on hover handlers
             * @param mapPoints
             * @private
             */
            _initMapPoints: function(mapPoints) {
                var self = this;

                _.each(mapPoints, function(mapPoint, index) {
                    var isActive = mapPoint.data.id == self._activePlaceId;
                    var clickHandler = function() {
                        self._detailsInfoBox.open(self._map, this);
                        self._loadInfoBoxContent(mapPoint);
                    };
                    var mouseOverHandler = function() {
                        this.setOptions({zIndex:self._markerIndex + 1});
                        self._tooltipInfoBox.setContent(self._getTooltipContent(mapPoint.data));
                        self._tooltipInfoBox.open(self._map, this);
                    };
                    var mouseOutHandler = function() {
                        self._tooltipInfoBox.close();
                    };
                    var zIndex = isActive ? 1000 : self._markerIndex++;

                    mapPoint.marker.setOptions({zIndex: zIndex});

                    window.google.maps.event.addListener(mapPoint.marker, 'click', clickHandler);
                    window.google.maps.event.addListener(mapPoint.marker, 'mouseover', mouseOverHandler);
                    window.google.maps.event.addListener(mapPoint.marker, 'mouseout', mouseOutHandler);
                });
            },

            /**
             *
             * @param event
             * @param requestData
             * @private
             */
            _onLoadContentSuccess: function(event, requestData) {
                if (event.state !== 'OK' || requestData.queryParams.token !== this._uid) {
                    return;
                }
                var self = this;
                if (requestData.route === this.option('placesRoute')) {
                    require([
                        'clientComponents/map/markerTooltip'
                    ], function(MarkerTooltip) {
                        if (self.isCreated) {
                            if (self._tooltipInfoBox) {
                                self._tooltipInfoBox.close();
                            }
                            self._tooltipTemplate = decodeURIComponent(event.meta.tooltipTemplate);
                            self._tooltipInfoBox = self._createTooltipInfoBox(MarkerTooltip);
                            self._detailsInfoBox = self._createDetailsInfoBox();
                        }
                        self._appendMapPoints(event.meta.places);
                        self.setIsLoading(false);
                    });
                } else if (requestData.route === this.option('placeDetailsRoute')){
                    this._detailsInfoBox.setContent($(event.html).get(0));
                }
            },

            /**
             * Loads detail infobox content
             * @param mapPoint
             * @private
             */
            _loadInfoBoxContent: function(mapPoint) {
                var options = {method: 'POST'};
                var params = {
                    token: this._uid,
                    place: JSON.stringify(mapPoint.data),
                    productSearch : this._productSearch
                };
                if (!this.option('detailInfoBoxFactory')) {
                    this._detailsInfoBox.setContent(this._loadingInfoBoxContent);
                } else {
                    this._detailsInfoBox.setContent(null);
                }

                this._requestHandler.send(this.option('placeDetailsRoute'), params, {}, options);
            },

            /**
             * Ajax error handler
             * @param requestData
             * @private
             */
            _onLoadContentError: function(requestData) {
                if ((requestData.route === this.option('placeDetailsRoute') && (requestData.queryParams.token === this._uid))){
                    this._detailsInfoBox.close();
                }
            },

          /**
           * Helps to stop event propagation when loading
           * @param event
           * @private
           */
            _loadingCaptureClickHandler: function(event) {
                if (this._isLoading) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            }

        });

        return MapComponent;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/map/map.js